import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fileSize'
})

export class FileSizePipe implements PipeTransform {

    transform(value: string, args?: number): any {
        let output;
        let bytes = parseInt(value);

        if (bytes < 1024) {
            output = bytes + ' Bytes';
        }
        else if (bytes < 1048576) {
            output = (bytes / 1024).toFixed(2) + ' KB';
        }
        else if (bytes < 1073741824) {
            output = (bytes / 1048576).toFixed(2) + ' MB';
        }
        else {
            output = (bytes / 1073741824).toFixed(2) + ' GB';
        }
        return output;
    }
}



// WEBPACK FOOTER //
// ./src/shared/filesize.pipe.ts